import { computed, makeObservable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroResultadosApreciacaoSessoesAnteriores extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    selecaoMultipla = true;

    get label() {
        return 'Resultados de apreciação em sessões anteriores';
    }

    constructor(props) {
        super(props);

        makeObservable(this, {
            carregandoDadosComplementares: computed
        });
    }

    getValorOpcao(registro) {
        const julgamentosAnteriores = registro?.detalhes?.julgamentosAnteriores;

        if (!julgamentosAnteriores?.length) {
            return [];
        }

        let retorno = [];

        julgamentosAnteriores.forEach((item) => {
            if (item.tipoResultadoJulgamento) {
                retorno.push(item.tipoResultadoJulgamento);
            }
        });

        return retorno;
    }

    getDescricao(valor) {
        let resultadoJulgamento = this.store.rootStore.dominioStore.tiposResultadoJulgamento.find(
            (tipoResultado) => tipoResultado.codigo === valor
        );

        return resultadoJulgamento ? resultadoJulgamento.descricao : 'Resultado de apreciação desconhecido: ' + valor;
    }

    get carregandoDadosComplementares() {
        return this.store.carregandoJulgamentosAnteriores;
    }

    renderCarregando() {
        return this.renderCircularProgress('resultados de apreciação em sessões anteriores...');
    }
}
